import { render, staticRenderFns } from "./UserActivityView.vue?vue&type=template&id=17595f2c&"
import script from "./UserActivityView.vue?vue&type=script&lang=js&"
export * from "./UserActivityView.vue?vue&type=script&lang=js&"
import style0 from "./UserActivityView.vue?vue&type=style&index=0&id=17595f2c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports